module.exports = __webpack_public_path__ + "static/media/Group 9.b38edac9.png";